/**
 * Opens Google Maps in a new tab showing directions to the provided latitude and longitude.
 *
 * @param {number} lat Latitude
 * @param {number} lon Longitude
 */
export function openGoogleMaps(lat, lon) {
  const googleMapsUrl = `https://www.google.com/maps/dir//${lat},${lon}`;
  window.open(googleMapsUrl, '_blank'); // Open the URL in a new tab
}

/**
 * Google Street View panorama URL for a point. Kept as a pure URL builder (no
 * window access) so both the waypoint and hike-highlight dialogs share exactly
 * one definition of the deep link, and so it can be unit-tested.
 */
export function googleStreetViewUrl(lat: number, lon: number): string {
  const params = new URLSearchParams({
    api: '1',
    map_action: 'pano',
    viewpoint: `${lat},${lon}`,
    heading: '0',
    pitch: '0',
    fov: '90',
  });
  return `https://www.google.com/maps/@?${params.toString()}`;
}

/**
 * Hike-planner URL seeded with a start point, used by "Plan a hike from here".
 */
export function hikePlannerStartUrl(origin: string, lat: number, lon: number): string {
  return `${origin}/hike-planner?startPoint=${lat},${lon}`;
}
